/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Nav_WarehouseInputs */

const vi_scl_nav_warehouse = /** @type {(inputs: Scl_Nav_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho lấy hương`)
};

/**

* @param {Scl_Nav_WarehouseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_nav_warehouse = /** @type {((inputs?: Scl_Nav_WarehouseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Nav_WarehouseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_nav_warehouse(inputs)
});